import React, { useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Typography } from "antd";
import { useLoader } from "../../Context/LoaderContext";
import { openNotification } from "../../Components/Notification";
import { isValidObjectId } from "../../Utils/generic-functions";
import subscriptionPurchaseService from "../../Service/subscription.purchase.service";
import "./transactionDetails.scss";

const TransactionDetails: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const subscriptionId = searchParams.get("subscriptionId");

  const { setLoading, setLoadingMessage } = useLoader();
  const pollingIntervalRef = useRef<NodeJS.Timeout | null>(null);

  const verifySubscription = async (id: string) => {
    setLoading(true);
    setLoadingMessage(
      "Verifying subscription  do not refresh or close the page..."
    );

    const pollVerification = async () => {
      try {
        const isVerified = await subscriptionPurchaseService.verifySubscriptionStatus(id, "active");
        
        if (isVerified) {
          if (pollingIntervalRef.current) {
            clearInterval(pollingIntervalRef.current);
            pollingIntervalRef.current = null;
          }
          setLoading(false);
          setLoadingMessage(null);
          navigate("/accounts", { replace: true });
        }
      } catch (error: any) {
        console.error("🚀 ~ verifySubscription ~ error:", error);
        if (pollingIntervalRef.current) {
          clearInterval(pollingIntervalRef.current);
          pollingIntervalRef.current = null;
        }
        setLoading(false);
        setLoadingMessage(null);
        openNotification("error", "Error verifying subscription", error.message);
      }
    };

    pollVerification();
  
    pollingIntervalRef.current = setInterval(pollVerification, 2000);
  };

  useEffect(() => {
    if (!subscriptionId) {
      navigate(-1);
    } else {
      const isMongoId = isValidObjectId(subscriptionId);
      if (!isMongoId) {
        navigate(-1);
      }
      verifySubscription(subscriptionId);
    }

    return () => {
      if (pollingIntervalRef.current) {
        clearInterval(pollingIntervalRef.current);
        pollingIntervalRef.current = null;
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subscriptionId,pollingIntervalRef]);
  return (
    <section className="dashboard-page transaction-details-page hide-scroll-bar">
      <div className="transaction-details-container">
        <Typography.Text type="secondary" style={{ margin: 0 }}>
          Subscription: #sub_{subscriptionId?.slice(0, 8)}
        </Typography.Text>

        <Typography.Title level={2} style={{ margin: 0 }}>
          THANK YOU!
        </Typography.Title>

        <Typography.Paragraph style={{ margin: 0 }}>
          We have received your payment. Your subscription is currently being
          verified. Please wait — you will be redirected within 1–2 minutes. Do
          not refresh or close this page
        </Typography.Paragraph>
      </div>
    </section>
  );
};

export default TransactionDetails;
